<script>
	import { slugify, currencyFormatter } from "cando-util";

	export let value;
	export let label = "currency input component";
	export let tabindex = 0;
	export let disabled = false;
	export let readonly = false;
	export let handleInputChange = () => {};
	export let cls = "input input-bordered input-primary rounded";
	export let key = "";
	export let itemId = "";

	const handleChange = (event) => {
		const el = event.target;

		const rawNumber = el.value.replace(/\D/g, "");
		const formatted = currencyFormatter.format(rawNumber);
		el.value = formatted;

		// If the inputType is not delete or arrow movement, snap cursor to end
		if (
			event.inputType !== "deleteContentBackward" &&
			event.inputType !== "deleteContentForward" &&
			event.inputType !== "insertFromPaste"
		) {
			requestAnimationFrame(() => {
				el.setSelectionRange(el.value.length, el.value.length);
			});
		}

		handleInputChange(event);
	};

	/*
	payment plan notes:
	1/2 up front
	the rest must be paid off in six months (6 addition payments)
	payments must be at least $500
	last payment can be a remainder
	for the document, we may just need to say a total and balance to paid in 6 mos.
	*/
</script>

<input
	id={`${slugify(label)}-input`}
	name={`${label}`}
	type="text"
	{tabindex}
	bind:value
	on:input={handleChange}
	class={cls}
	autocomplete="off"
	aria-autocomplete="none"
	{disabled}
	{readonly}
	{key}
	{itemId}
/>
